import { render, staticRenderFns } from "./RedirecionaEditarUsuario.vue?vue&type=template&id=f80dabdc&scoped=true"
import script from "./RedirecionaEditarUsuario.vue?vue&type=script&lang=js"
export * from "./RedirecionaEditarUsuario.vue?vue&type=script&lang=js"
import style0 from "./RedirecionaEditarUsuario.vue?vue&type=style&index=0&id=f80dabdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80dabdc",
  null
  
)

export default component.exports